import React from 'react';
import PropTypes from 'prop-types';
import { formatInforMarkerTruck } from 'react/utils/routeProgressBarUtils';

function Label({ routeView }) {
  const value = formatInforMarkerTruck(routeView);
  const dateFormatted = Monet.Format.Date
    .formatToLocale(routeView.route.date, { dayMonthOnly: true });
  const routeLabel = `${value} (${dateFormatted})`;

  return (
    <div className="routeMonitorFilterItemRouteKey">
      {routeLabel}
    </div>
  );
}

Label.propTypes = {
  routeView: PropTypes.object.isRequired
};

export default Label;
